import React from "react"
import { batch, useSignal } from "@preact/signals-react"

import { AppAsyncOfficesAutocomplete } from "@components"
import { errors, offices, officesOptions } from "@signals"


export default function OfficesAutocomplete({ ...props }) {
	const justRendered = useSignal(true)
	return <AppAsyncOfficesAutocomplete
		value={offices.value || null}
		error={errors.value?.offices}
		onChange={e => batch(() => {
			offices.value = e.target.value
		})}
		onFinishAjax={options => {
			if (!props.multiple) {
				if (props?.autoSelect && justRendered.value) {
					offices.value = options[0]?.value || offices.value || null
				} else {
					offices.value = options?.filter(d => d?.selected)[0]?.value || offices.value || null
				}
			}
			officesOptions.value = officesOptions.value.length ? officesOptions.value.map(a => {
				return {
					...a,
					...options.some(b => b.value === a.value) && {
						officeNoResults: options.officeNoResults
					}
				}
			}) : options
			justRendered.value = false
		}
		}
		filters={{
			selected: offices.value,
			...props?.filters
		}}
		{...props}
	/>
}